export const includesSubString = (string = '', substring) => {
  return string
    .toString()
    .toLowerCase()
    .includes(substring);
};

export const swapImageEndpointForDownload = url => {
  if (!url) {
    return;
  }
  // Due to Chrome blocking download attributes on cross origin requests, we added certain
  // folders as custom origins on our CDN. These images can now be used properly by replacing
  // the below "badUrl", with the appropriate environment url, or relative path
  //
  // Current folders which work with CDN:
  // `/marketing-logos`, `/marketing-brochures`, `/technical-publications`
  // Additional info: https://applydigital.atlassian.net/browse/AGIDS-272

  const badUrl = 'https://agifileintegrations.blob.core.windows.net/';
  const relativePath = '/';

  return url.match(badUrl) && window.location.hostname !== 'localhost'
    ? url.replace(badUrl, relativePath)
    : url;
};

export const mapNameIfParentNull = parentObj => {
  return parentObj ? parentObj : { Name: 'N/A' };
};
